import { CommonModule } from '@angular/common';
import { NgModule } from '@angular/core';
import { FormsModule, ReactiveFormsModule } from '@angular/forms';
import { CmydFormErrorComponent } from './cmyd-form-error.component';
import { CmydFormErrorDirective } from './cmyd-form-error.directive';



@NgModule({
  declarations: [
    CmydFormErrorComponent,
    CmydFormErrorDirective
  ],
  imports: [
    CommonModule,
    FormsModule,
    ReactiveFormsModule
  ],
  exports: [
    CmydFormErrorDirective
  ]
})
export class CmydFormErrorModule { }
